import { Component, model } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbCalendar, NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions, NgbModule, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { LocationServiceService } from '../../Model/LocationMaster/location-service.service';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { CommonService } from '../../Model/Common/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ViewofReductonConfirmationListComponent } from '../viewof-reducton-confirmation-list/viewof-reducton-confirmation-list.component';
import { DesignationWiseSummaryComponent } from '../designation-wise-summary/designation-wise-summary.component';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-addition-of-manpower',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepicker, DataTablesModule, JsonPipe, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './addition-of-manpower.component.html',
  styleUrl: './addition-of-manpower.component.scss'
})
export class AdditionOfManpowerComponent {
  editMode: boolean = false;
  isDisabled: boolean = false;
  BranchMaster: any[] = [];
  DesignationLoad: any[] = [];
  Shift: any[] = [];
  ClientLoad: any[] = [];
  DutyLoad: any[] = [];
  SiteLoad: any[] = [];
  AddManpowerTable: any[] = [];
  NoOfEmp: number = 0;
  BranchId: number = 0;
  BranchName: string = '';
  ClientId: number = 0;
  ClientName: string = '';
  Designation: string = '';
  DesignationId: number = 0;
  ShiftTitle: string = '';
  ShiftID: number = 0;
  DutyId: number = 0;
  Duty: string = '';
  SiteId: number = 0;
  SiteName: string = '';
  //  selectedFiles: File[] = [];
  selectedFile: File | null = null;
  displayedFileName: string | null = null;
  dtTrigger: Subject<any> = new Subject<any>();
  Remark: string = ''
  public User: any = null;
  Image: any = null
  ImageUrl: any;
  WorkOrderDate: any = null;
  WorkOrderDateObj: any = null;
  FromDateObj: any;
  ToDateObj: any;
  FromDate: any = null;
  ToDate: any = null;
  EffectiveDate: any = null;
  EffectiveDateObj: any = null;
  ToDateValidation: any = null
  WorkOrderNumber: string = ''
  AllocationType: string = 'Addition'
  Index: number = 0;
  TotalAllotedManpower: number = 0;
  IsMonthLocked: number = 0
  EntryNo: number = 0;
  objdata = {
    editMode: false,
    AllocationType: '',
    Id: 0,
    wono: '',
    siteMode: false,
    bid: 0,
    cid: 0,
    sid: 0,
    Type: '',
  }
  Total: number = 0
  CurrentDate: any = null;
  RefID: number = 0;
  dtoptions: DataTables.Settings = {};
  constructor(private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private siteadditionreduction: AdditionOfManpowerService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService,
    private route: ActivatedRoute,
    private tooltip: TooltipService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  async ngOnInit(): Promise<void> {
    // this.ComboLoad('Branch');
    // this.ComboLoad('Designation');
    // this.ComboLoad('Duty');
    // this.ComboLoad('shift');
    // this.CurDate('RegistrationDate');
    // this.initializeComponent();
    // this.setupDataTableOptions();
    // if (this.objdata.AllocationType === 'O') {
    //   this.AllocationType = 'Opening'
    // }
    try {
      this.isDisabled = true
      await Promise.all([
        this.ComboLoad('Branch'),
        this.ComboLoad('Designation'),
        this.ComboLoad('Duty'),
        this.ComboLoad('shift'),
        this.CurDate('RegistrationDate')
      ]);
      this.initializeComponent();
      if (this.objdata.AllocationType === 'O') {
        this.AllocationType = 'Opening';
      }
      this.isDisabled = false
    } catch (error) {
      console.error('Error during initialization:', error);
    }
  }

  initializeComponent(): void {
    this.calculateTotalAllotedManpower();
    this.route.queryParams.subscribe(params => {
      this.handleQueryParams(params);
      this.loadInitialData();
    });
  }

  handleQueryParams(params: any): void {
    this.objdata = {
      editMode: params['editMode'],
      AllocationType: params['AllocationType'],
      Id: params['Id'],
      wono: params['wono'],
      siteMode: params['siteMode'],
      bid: parseInt(params['bid']),
      cid: parseInt(params['cid']),
      sid: parseInt(params['sid']),
      Type: params['Type']
    };
    this.CurrentDate = params['Date'];
  }
  // loadInitialData(): void {
  //   if (this.objdata.siteMode) {
  //     this.Loadata();
  //   }
  //   if (this.objdata.editMode) {
  //     this.getData();
  //   }
  //   this.Count();
  // }
  async loadInitialData(): Promise<void> {
    try {
      if (this.objdata.siteMode) {
        await this.Loadata();
      }
      if (this.objdata.editMode) {
        await this.getData();
      }
      this.Count();
    } catch (error) {
      console.error('Error loading initial data:', error);
    }
  }
  //Above are for optimization

  CurDate(SelectType: string) {
    this.isDisabled = true
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': '', 'JoiningDate': '', }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.CurrentDate = response.Table[0].RegistrationDate;
          // this.isDisabled = false
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => { this.isDisabled = false },
    });
  }
  async Loadata() {
    try {
      this.BranchId = this.objdata.bid;

      await this.ComboLoad('Client');
      this.ClientId = this.objdata.cid;

      await this.ComboLoad('Site');
      this.SiteId = this.objdata.sid;

      //this.ComboLoad('Designation');
      // this.Count();
    } catch (error) {
      console.error('Error loading data', error);
    }
  }

  onSelectChange(type: string) {
    if (type === 'Designation') {
      const selected = this.DesignationLoad.find(designation => designation.DesignationMasterID === this.DesignationId);
      this.Designation = selected ? selected.DesignationName : null;
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = 0
      this.ClientName = ''
      this.SiteId = 0
      this.SiteName = ''
      this.DesignationId = 0
      this.Designation = ''
      this.DutyId = 0
      this.Duty = ''
      this.Total = 0
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteId = 0
      this.SiteName = ''
      this.Total = 0
    }
    else if (type === 'Shift') {
      const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
      this.ShiftTitle = selected ? selected.ShiftTitle : null;
    }
    else if (type === 'Duty') {
      const selected = this.DutyLoad.find(duty => duty.DutyMasterID === this.DutyId);
      this.Duty = selected ? selected.DutyName : null;
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.DesignationId = 0
      this.Designation = ''
      this.Count();
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      'DesignationId': (Combotype == 'Duty') ? this.DesignationId : 0,
      'EmpType': ''
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Branch') {
            this.BranchMaster = response.ComboLoad;
            const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
            this.BranchName = selected ? selected.BranchName : null;

          } else if (Combotype == 'Client') {
            this.ClientLoad = response.ComboLoad;
            const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
            this.ClientName = selected ? selected.ClientGroupName : null;

          } else if (Combotype == 'Site') {
            this.SiteLoad = response.ComboLoad;
            const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
            this.SiteName = selected ? selected.SiteName : null;

          } else if (Combotype == 'Designation') {
            this.DesignationLoad = response.ComboLoad;

          } else if (Combotype == 'Duty') {
            this.DutyLoad = response.ComboLoad;

          }
          else if (Combotype == 'shift') {
            this.Shift = response.ComboLoad;

          }
        }
        else {
          this.toast.show({ message: 'No Data is there in Load', type: toastTypeEnum.warning });
        }

      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
    }
  }
  removeFile() {
    this.selectedFile = null;
    this.displayedFileName = null;
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.ImageUrl, '_blank');
  }

  async save() {
    await this.common.getPageRights();
    if (this.WorkOrderNumber && !this.WorkOrderDate) {
      this.toast.show({ message: 'Please select Work Order Date', type: toastTypeEnum.warning });
      return;
    }
    this.WorkOrderDateObj = this.dateFormate.format(this.WorkOrderDate);
    if (this.WorkOrderDate && !this.validateDateFormat(this.WorkOrderDateObj)) {
      this.toast.show({ message: 'Please enter Work Order Date in DDMMMYYYY Format!', type: toastTypeEnum.warning });
      this.WorkOrderDate = '';
      this.WorkOrderDateObj = '';
      this.isDisabled = false
      return;
    }
    if (!this.BranchId || this.BranchId === 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ClientId || this.ClientId === 0) {
      this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.SiteId || this.SiteId === 0) {
      this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.objdata.editMode && this.AddManpowerTable.length === 0) {
      this.toast.show({ message: 'Please add Manpower Details!', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (result) {
        if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
          if (this.objdata.editMode) {
            this.CheckValidation1('WO');
          }
          else {
            this.CheckManpowerValidation('WO');
          }
        }
        else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }
    }).catch(() => {

    });
  }

  CheckManpowerValidation(SelecType: string) {
    const manpower = this.AddManpowerTable.length > 0 ? this.AddManpowerTable.map(site => {
      return {
        DesignationId: site.DesignationId,
        DutyId: site.DutyId,
        ShiftId: site.ShiftId,
        FromDate: site.FromDate,
        ToDate: site.ToDate,
        NoOfPerson: site.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: site.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: site.Remarks,
        ESS_ShiftWiseManpowerDetailsId: site.ESS_ShiftWiseManpowerDetailsId
      };
    }) : [];
    const validation = {
      SelectType: SelecType,
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetails: manpower,
      AllocationType: this.objdata.AllocationType,
      WoNo: this.WorkOrderNumber,
      SiteId: this.SiteId,
    };
    this.siteadditionreduction.ESS_SiteManpowerValidation(validation).subscribe(
      data => {
        if (data.Table[0].Column1 === '01') {
          this.Insertupdate();
        } else {
          const modalRef = this.modalService.open(ViewofReductonConfirmationListComponent, {
            size: data.Table2.length > 0 ? 'xl' : 'lg',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          if (data.Table2.length > 0) {
            modalRef.componentInstance.Dataa = data.Table2;
          }
          modalRef.componentInstance.Message = data.Table1[0].Column1;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Insertupdate();
            }
          }).catch(() => {

          });
        }
      }
    );
  }
  CheckValidation1(selectType: string) {
    const manpower = this.AddManpowerTable.length > 0 ? this.AddManpowerTable.map(site => {
      return {
        DesignationId: site.DesignationId,
        DutyId: site.DutyId,
        ShiftId: site.ShiftId,
        FromDate: site.FromDate,
        ToDate: site.ToDate,
        NoOfPerson: site.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: site.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: site.Remarks,
        ESS_ShiftWiseManpowerDetailsId: site.ESS_ShiftWiseManpowerDetailsId
      };
    }) : [];
    const validation = {
      SelectType: selectType,
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetails: manpower,
      AllocationType: this.objdata.AllocationType,
      WoNo: this.WorkOrderNumber,
      SiteId: this.SiteId,
    };

    this.siteadditionreduction.ESS_SiteManpowerValidation(validation).subscribe(
      data => {
        if (data.Table[0].Column1 === '01') {
          this.CheckManpowerValidation('U');

        } else {
          const modalRef = this.modalService.open(ViewofReductonConfirmationListComponent, {
            size: 'lg',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          if (data && data.Table2 && data.Table2.length > 0) {
            modalRef.componentInstance.Dataa = data.Table2;
          }
          modalRef.componentInstance.Message = data.Table1[0].Column1;;
          modalRef.result.then((result: any) => {
            if (result) {
              this.CheckManpowerValidation('U');
            }
          }).catch(() => {

          });
        }
      }
    );
  }

  Insertupdate() {
    this.FromDateObj = this.dateFormate.format(this.FromDate);
    this.ToDateObj = this.ToDate === null || this.ToDate === '' ? '' : this.dateFormate.format(this.ToDate);
    this.WorkOrderDateObj = this.dateFormate.format(this.WorkOrderDate);
    this.isDisabled = true
    const manpower = this.AddManpowerTable.map(site => {
      return {
        DesignationId: site.DesignationId,
        DutyId: site.DutyId,
        ShiftId: site.ShiftId,
        FromDate: site.FromDate,
        ToDate: site.ToDate,
        NoOfPerson: site.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: '',
        Remarks: site.Remarks,
        ESS_ShiftWiseManpowerDetailsId: site.ESS_ShiftWiseManpowerDetailsId
      };
    });
    const additionData = {
      SelectType: this.objdata.editMode ? 'U' : 'I',
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetailsId: '',
      ESS_ShiftWiseManpowerDetails: manpower,
      WoNo: this.WorkOrderNumber,
      WoDate: this.WorkOrderDateObj,
      SiteId: this.SiteId,
      UserID: this.User.UserId,
      AllocationType: 'A',
      Attachment: this.displayedFileName
    };

    this.siteadditionreduction.ESS_SiteManpowerAdditionReduction(additionData).subscribe(
      data => {
        if (data.Error_Code == '365' || data.Error_Code == '368') {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              if (this.objdata.Type == 'V') {
                this.router.navigate(['master/ViewAllocateManpower']);
              }
              else {
                this.router.navigate(['master/sitewisemanpowersummary']);
              }
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
      },
      error => {
        console.error('Error:', error);
      });
  }

  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'AdditonOfManpower', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          // this.toast.show({ message: 'File uploaded successfully', type: toastTypeEnum.success });
          this.displayedFileName = response.FileName;
          this.ImageUrl = response.Url;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  getData() {
    const data = {
      SelectType: 'S',
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetailsId: '',
      AllocationType: this.objdata.AllocationType,
      WoNo: this.objdata.wono,
      SiteId: '',
      DesignationId: '',
      DutyId: '',
      ShiftId: '',
      AsOnDate: this.CurrentDate
    }
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.AddManpowerTable = Object.values(data.Table);

          this.AddManpowerTable.forEach(record => {
            record.FromDate = this.removeLeadingZero(record.FromDate);
          });

          this.EntryNo = data.Table[0].EntryNo;
          this.WorkOrderNumber = this.objdata.wono;
          this.WorkOrderDate = this.dateFormate.parse(data.Table[0].WODate);
          this.displayedFileName = data.Table[0].Attachment;

          //this.ComboLoad('Branch');
          this.BranchId = data.Table[0].BranchId;
          const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
          this.BranchName = selected ? selected.BranchName : null;

          this.ComboLoad('Client');
          this.ClientId = data.Table[0].ClientId;
          const selected1 = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
          this.ClientName = selected1 ? selected1.ClientGroupName : null;

          this.ComboLoad('Site');
          this.SiteId = data.Table[0].SiteId;
          const selected2 = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
          this.SiteName = selected2 ? selected2.SiteName : null;

          this.ImageUrl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AdditonOfManpower' + '/' + data.Table[0].Attachment;
          this.calculateTotalAllotedManpower();
          this.Count();
        }

      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
      () => {
        this.isDisabled = false;
      }
    );
  }
  removeLeadingZero(dateString: string): string {
    if (!dateString) return '';
    const [day, month, year] = dateString.split(' ');
    const formattedDay = parseInt(day, 10);
    return `${formattedDay} ${month} ${year}`;
  }

  validateInputs(): boolean {
    if (this.WorkOrderNumber && !this.WorkOrderDate) {
      this.toast.show({ message: 'Please select Work Order Date', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.BranchId || this.BranchId === 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.ClientId || this.ClientId === 0) {
      this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.SiteId || this.SiteId === 0) {
      this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.DesignationId || this.DesignationId === 0) {
      this.toast.show({ message: 'Please select Designation!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.DutyId || this.DutyId === 0) {
      this.toast.show({ message: 'Please select Duty!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.ShiftID || this.ShiftID === 0) {
      this.toast.show({ message: 'Please select Shift!', type: toastTypeEnum.warning });
      return false;
    }
    if (this.NoOfEmp <= 0) {
      this.toast.show({ message: 'Please Enter No. Of Manpower!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.FromDate) {
      this.toast.show({ message: 'Please select From Date', type: toastTypeEnum.warning });
      return false;
    }

    if (this.isDuplicateEntry()) {
      this.toast.show({ message: 'Duplicate entry found , as we cannot add the same record!', type: toastTypeEnum.warning });
      return false;
    }
    return true;
  }

  refresh() {
    if (this.objdata.Type == 'V') {
      this.router.navigate(['master/ViewAllocateManpower']);
    }
    else {
      this.router.navigate(['master/sitewisemanpowersummary']);
    }
    //this.router.navigate(['master/sitewisemanpowersummary']);
  }
  add() {
    if (!this.validateInputs()) {
      return;
    }
    this.isDisabled = true
    this.FromDateObj = this.dateFormate.format(this.FromDate);
    this.ToDateObj = this.dateFormate.format(this.ToDate);
    this.EffectiveDateObj = this.dateFormate.format(this.EffectiveDate);
    const fromDate = new Date(this.FromDateObj);
    const toDate = new Date(this.ToDateObj);
    if (toDate < fromDate) {
      this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
      this.ToDate = '';
      this.ToDateObj = '';
      this.EffectiveDate = '';
      this.EffectiveDateObj = '';
      this.isDisabled = false
      return
    }
    if (this.ToDate && !this.validateDateFormat(this.ToDateObj)) {
      this.toast.show({ message: 'Please enter To Date in DDMMMYYYY Format!', type: toastTypeEnum.warning });
      this.ToDate = '';
      this.ToDateObj = '';
      this.EffectiveDate = '';
      this.EffectiveDateObj = '';
      this.isDisabled = false
      return;
    }
    var Data = {
      BranchId: this.BranchId,
      BranchName: this.BranchName,
      ClientId: this.ClientId,
      ClientGroupName: this.ClientName,
      SiteId: this.SiteId,
      SiteName: this.SiteName,
      DesignationId: this.DesignationId,
      DesignationName: this.Designation,
      DutyId: this.DutyId,
      DutyName: this.Duty,
      ShiftId: this.ShiftID,
      ShiftTitle: this.ShiftTitle,
      FromDate: this.FromDateObj,
      ToDate: this.ToDateObj,
      NoOfPerson: this.NoOfEmp,
      Remarks: this.Remark,
      ReductionEffectiveAfter: this.EffectiveDateObj
    };
    // if (this.editMode) {
    //   this.AddManpowerTable[this.Index] = Data;
    //   this.isDisabled = false
    // } else {
    //   this.AddManpowerTable.push(Data);
    //   this.isDisabled = false
    // }
    if (this.editMode) {
      this.AddManpowerTable[this.Index] = {
        ...this.AddManpowerTable[this.Index],
        ...Data
      };
      this.isDisabled = false;
      this.toast.show({ message: 'Manpower Edited in the List!', type: toastTypeEnum.success });
    } else {
      this.AddManpowerTable.push(Data);
      this.isDisabled = false;
      this.toast.show({ message: 'Manpower Added in the List!', type: toastTypeEnum.success });
    }
    this.editMode = false;

    this.calculateTotalAllotedManpower()
    this.clear();
  }

  validateDateFormat(date: any) {
    const regex = /^\d{1,2} [A-Za-z]{3} \d{4}$/;
    return regex.test(date);
  }

  onEditClick(element: any, index: number): void {
    this.Index = index;
    this.editMode = true;
    // this.BranchId = element.BranchId;
    // this.BranchName = element.BranchName;
    // this.ClientId = element.ClientId;
    // this.ClientName = element.ClientGroupName;
    // this.SiteId = element.SiteId;
    // this.SiteName = element.SiteName;

    this.DesignationId = element.DesignationId;
    this.Designation = element.DesignationName;

    this.DutyId = element.DutyId;
    this.Duty = element.DutyName;
    this.ShiftID = element.ShiftId;
    this.ShiftTitle = element.ShiftTitle;
    this.FromDate = this.dateFormate.parse(element.FromDate);
    this.ToDate = this.dateFormate.parse(element.ToDate);
    this.EffectiveDate = this.dateFormate.parse(element.ReductionEffectiveAfter);
    this.ToDateValidation = this.dateFormate.parse(element.ToDate);
    this.NoOfEmp = element.NoOfPerson;
    this.Remark = element.Remarks;
    this.RefID = element.ESS_ShiftWiseManpowerDetailsId != null ? element.ESS_ShiftWiseManpowerDetailsId : 0;

    this.calculateTotalAllotedManpower()
  }
  clear() {
    this.RefID = 0;
    this.editMode = false;
    this.NoOfEmp = 0;
    this.DesignationId = 0;
    this.DutyId = 0;
    this.ShiftID = 0;
    this.FromDate = '';
    this.ToDate = '';
    this.EffectiveDate = ''
    this.Remark = '';
    this.ToDateValidation = null
  }

  isDuplicateEntry(): boolean {
    this.FromDateObj = this.dateFormate.format(this.FromDate);
    const newSiteID = this.SiteId;
    const newDesignationId = this.DesignationId;
    const newDutyId = this.DutyId;
    const newShiftID = this.ShiftID;
    const newFromDate = this.FromDateObj;

    return this.AddManpowerTable.some((entry, idx) => {
      if (this.editMode && idx === this.Index) {
        return false;
      }

      const siteMatches = entry.SiteId === newSiteID;
      const designationMatches = entry.DesignationId === newDesignationId;
      const dutyMatches = entry.DutyId === newDutyId;
      const shiftMatches = entry.ShiftId === newShiftID;
      const fromDateMatches = entry.FromDate === newFromDate;

      return siteMatches && designationMatches && dutyMatches && shiftMatches && fromDateMatches;
    });
  }

  calculateTotalAllotedManpower() {
    this.TotalAllotedManpower = this.AddManpowerTable.reduce((total, shift) => {
      return total + shift.NoOfPerson;
    }, 0);
  }
  deleteRow(index: number): void {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Delete?'

    modalRef.result.then((result: any) => {
      if (result) {
        this.AddManpowerTable.splice(index, 1);
        this.calculateTotalAllotedManpower();
      }
    }).catch(() => {

    });

  }
  onKeyPress(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57 || input.value.length >= 7) {
      event.preventDefault();
    }
  }

  OpenDesignationSummary() {
    if (!this.BranchId || this.BranchId === 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ClientId || this.ClientId === 0) {
      this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.SiteId || this.SiteId === 0) {
      this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      return;
    }
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    };
    const data = {
      SelectType: 'D',
      RegionId: '',
      BranchId: this.BranchId,
      ZoneId: '',
      ClientId: this.ClientId,
      SiteId: this.SiteId,
      SupervisorId: '',
      AsOnDate: this.CurrentDate
    }
    const modalRef = this.modalService.open(DesignationWiseSummaryComponent, modalOptions);
    modalRef.componentInstance.dData = data;
    modalRef.componentInstance.edit = false;
  }

  Count() {
    const data = {
      SelectType: 'Count',
      RegionId: '',
      BranchId: this.BranchId,
      ZoneId: '',
      ClientId: this.ClientId,
      SiteId: this.SiteId,
      SupervisorId: '',
      AsOnDate: this.CurrentDate
    }
    console.log('count', data);
    this.isDisabled = true
    this.siteadditionreduction.ESS_SiteManpowerSummary(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.Total = data.Table[0].NoOfPerson;
          console.log('value', this.Total);
          // this.isDisabled = false
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
      () => {
        this.isDisabled = false;
      }
    );
  }

  CheckIsDisabled() {
    return this.RefID == 0 ? false : (this.RefID > 0 && (this.ToDateValidation != null && this.ToDateValidation != '') && this.editMode && this.objdata.editMode) ? false : true;
  }
  onToDateChange() {
    if (this.ToDate) {
      this.updateEffectiveDate();
    } else {
      this.EffectiveDate = null;
    }
  }
  updateEffectiveDate(): void {
    if (this.ToDate) {
      const date = new Date(this.ToDate.year, this.ToDate.month - 1, this.ToDate.day);
      date.setDate(date.getDate() + 1);
      this.EffectiveDate = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
    }
  }
}